import { Button } from "ui/button";

export type CollegeProfileEditActionsProps = {
  isEditing: boolean;
  isSaving?: boolean;
  editLabel?: string;
  saveDisabled?: boolean;
  /** Disables the "Edit" trigger, e.g. while the underlying value is still loading. */
  isEditDisabled?: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onSave?: () => void;
  /** When set, the Save button submits this form id instead of calling `onSave`. */
  submitFormId?: string;
};

/**
 * Shared inline Edit / Save+Cancel control trio used by College profile
 * sections that own their own local edit-mode state.
 */
const CollegeProfileEditActions = ({
  isEditing,
  isSaving = false,
  editLabel = "Edit",
  saveDisabled = false,
  isEditDisabled = false,
  onEdit,
  onCancel,
  onSave,
  submitFormId,
}: CollegeProfileEditActionsProps) => {
  if (!isEditing) {
    return (
      <Button variant="outlined" size="medium" onClick={onEdit} disabled={isEditDisabled}>
        {editLabel}
      </Button>
    );
  }

  return (
    <>
      <Button variant="text" size="medium" onClick={onCancel} disabled={isSaving}>
        Cancel
      </Button>
      <Button
        variant="contained"
        size="medium"
        type={submitFormId ? "submit" : "button"}
        form={submitFormId}
        onClick={submitFormId ? undefined : onSave}
        loading={isSaving}
        disabled={saveDisabled || isSaving}
      >
        Save changes
      </Button>
    </>
  );
};

export default CollegeProfileEditActions;
